import styled from 'styled-components/macro';

export const Container = styled.div`
    background-color: #fff;
    border-radius: 2px;
`;
